module.exports = __webpack_public_path__ + "static/img/product_img_4.8068467.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/product_img_4.png
// module id = DJCd
// module chunks = 22